@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.gems.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.gems.resources/"

@delegate:ResourceContentHash(2_143_998_426)
internal val Res.string.gems_region_gilan: StringResource by lazy {
      StringResource("string:gems_region_gilan", "gems_region_gilan", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6885, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5753, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5257, 33),
      ))
    }

@delegate:ResourceContentHash(-1_386_616_182)
internal val Res.string.gems_region_hormozgan: StringResource by lazy {
      StringResource("string:gems_region_hormozgan", "gems_region_hormozgan", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6927, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5787, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5291, 41),
      ))
    }

@delegate:ResourceContentHash(472_745_892)
internal val Res.string.gems_region_isfahan: StringResource by lazy {
      StringResource("string:gems_region_isfahan", "gems_region_isfahan", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6977, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5829, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5333, 39),
      ))
    }

@delegate:ResourceContentHash(886_294_240)
internal val Res.string.gems_region_kerman: StringResource by lazy {
      StringResource("string:gems_region_kerman", "gems_region_kerman", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7076, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5916, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5420, 34),
      ))
    }

@delegate:ResourceContentHash(597_829_136)
internal val Res.string.gems_region_kermanshah: StringResource by lazy {
      StringResource("string:gems_region_kermanshah", "gems_region_kermanshah", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7021, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5869, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5373, 46),
      ))
    }

@delegate:ResourceContentHash(-127_743_648)
internal val Res.string.gems_region_khorasan: StringResource by lazy {
      StringResource("string:gems_region_khorasan", "gems_region_khorasan", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7119, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5951, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5455, 40),
      ))
    }

@delegate:ResourceContentHash(-1_421_690_591)
internal val Res.string.gems_region_khuzestan: StringResource by lazy {
      StringResource("string:gems_region_khuzestan", "gems_region_khuzestan", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7164, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5992, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5496, 41),
      ))
    }

@delegate:ResourceContentHash(349_771_326)
internal val Res.string.gems_region_kurdistan: StringResource by lazy {
      StringResource("string:gems_region_kurdistan", "gems_region_kurdistan", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7214, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6038, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5538, 41),
      ))
    }

@delegate:ResourceContentHash(1_280_847_707)
internal val Res.string.gems_region_mashhad: StringResource by lazy {
      StringResource("string:gems_region_mashhad", "gems_region_mashhad", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7264, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6080, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5580, 39),
      ))
    }

@delegate:ResourceContentHash(723_160_112)
internal val Res.string.gems_region_mazandaran: StringResource by lazy {
      StringResource("string:gems_region_mazandaran", "gems_region_mazandaran", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7304, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6120, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5620, 46),
      ))
    }

@delegate:ResourceContentHash(-437_387_749)
internal val Res.string.gems_region_other: StringResource by lazy {
      StringResource("string:gems_region_other", "gems_region_other", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7359, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6167, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5667, 45),
      ))
    }

@delegate:ResourceContentHash(-479_808_622)
internal val Res.string.gems_region_qazvin: StringResource by lazy {
      StringResource("string:gems_region_qazvin", "gems_region_qazvin", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7413, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6213, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5713, 34),
      ))
    }

@delegate:ResourceContentHash(-1_639_912_041)
internal val Res.string.gems_region_shiraz: StringResource by lazy {
      StringResource("string:gems_region_shiraz", "gems_region_shiraz", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7456, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6248, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5748, 34),
      ))
    }

@delegate:ResourceContentHash(1_460_018_573)
internal val Res.string.gems_region_sistan: StringResource by lazy {
      StringResource("string:gems_region_sistan", "gems_region_sistan", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7499, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6283, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5783, 54),
      ))
    }

@delegate:ResourceContentHash(1_763_745_857)
internal val Res.string.gems_region_tabriz: StringResource by lazy {
      StringResource("string:gems_region_tabriz", "gems_region_tabriz", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7570, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6342, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5838, 34),
      ))
    }

@delegate:ResourceContentHash(-1_389_706_510)
internal val Res.string.gems_region_tehran: StringResource by lazy {
      StringResource("string:gems_region_tehran", "gems_region_tehran", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7613, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6377, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5873, 34),
      ))
    }

@delegate:ResourceContentHash(-809_951_537)
internal val Res.string.gems_region_yazd: StringResource by lazy {
      StringResource("string:gems_region_yazd", "gems_region_yazd", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7656, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6416, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5908, 32),
      ))
    }

@delegate:ResourceContentHash(-952_427_250)
internal val Res.string.gems_report_action: StringResource by lazy {
      StringResource("string:gems_report_action", "gems_report_action", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7689, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6449, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5941, 34),
      ))
    }

@delegate:ResourceContentHash(-1_644_632_772)
internal val Res.string.gems_report_done: StringResource by lazy {
      StringResource("string:gems_report_done", "gems_report_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7732, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6488, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5976, 32),
      ))
    }

@delegate:ResourceContentHash(911_005_598)
internal val Res.string.gems_report_failed: StringResource by lazy {
      StringResource("string:gems_report_failed", "gems_report_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7777, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6525, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6009, 78),
      ))
    }

@delegate:ResourceContentHash(-1_448_921_927)
internal val Res.string.gems_report_reason_offensive: StringResource by lazy {
      StringResource("string:gems_report_reason_offensive", "gems_report_reason_offensive", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7900, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6620, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6088, 72),
      ))
    }

@delegate:ResourceContentHash(1_288_578_917)
internal val Res.string.gems_report_reason_other: StringResource by lazy {
      StringResource("string:gems_report_reason_other", "gems_report_reason_other", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7993, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6693, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6161, 52),
      ))
    }

@delegate:ResourceContentHash(-295_939_024)
internal val Res.string.gems_report_reason_spam: StringResource by lazy {
      StringResource("string:gems_report_reason_spam", "gems_report_reason_spam", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8050, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6742, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6214, 55),
      ))
    }

@delegate:ResourceContentHash(-1_053_217_039)
internal val Res.string.gems_report_sent: StringResource by lazy {
      StringResource("string:gems_report_sent", "gems_report_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8142, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6802, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6270, 72),
      ))
    }

@delegate:ResourceContentHash(-1_054_499_435)
internal val Res.string.gems_report_submit: StringResource by lazy {
      StringResource("string:gems_report_submit", "gems_report_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8247, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6883, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6343, 46),
      ))
    }

@delegate:ResourceContentHash(-180_474_526)
internal val Res.string.gems_report_title: StringResource by lazy {
      StringResource("string:gems_report_title", "gems_report_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8302, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6942, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6390, 53),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.gems_retry: StringResource by lazy {
      StringResource("string:gems_retry", "gems_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8368, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6996, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6444, 30),
      ))
    }

@delegate:ResourceContentHash(772_191_497)
internal val Res.string.gems_save_a11y: StringResource by lazy {
      StringResource("string:gems_save_a11y", "gems_save_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8415, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7031, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6475, 30),
      ))
    }

@delegate:ResourceContentHash(-367_345_342)
internal val Res.string.gems_saved_action_a11y: StringResource by lazy {
      StringResource("string:gems_saved_action_a11y", "gems_saved_action_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8454, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7070, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6506, 50),
      ))
    }

@delegate:ResourceContentHash(-156_427_341)
internal val Res.string.gems_saved_empty: StringResource by lazy {
      StringResource("string:gems_saved_empty", "gems_saved_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8545, 188),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7137, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6557, 112),
      ))
    }

@delegate:ResourceContentHash(-367_345_342)
internal val Res.string.gems_saved_rail: StringResource by lazy {
      StringResource("string:gems_saved_rail", "gems_saved_rail", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8734, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7290, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6670, 43),
      ))
    }

@delegate:ResourceContentHash(-367_345_342)
internal val Res.string.gems_saved_sheet_title: StringResource by lazy {
      StringResource("string:gems_saved_sheet_title", "gems_saved_sheet_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8818, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7350, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6714, 50),
      ))
    }

@delegate:ResourceContentHash(752_516_460)
internal val Res.string.gems_search_close_a11y: StringResource by lazy {
      StringResource("string:gems_search_close_a11y", "gems_search_close_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8909, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7417, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6765, 46),
      ))
    }

@delegate:ResourceContentHash(-670_390_915)
internal val Res.string.gems_search_open_a11y: StringResource by lazy {
      StringResource("string:gems_search_open_a11y", "gems_search_open_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8972, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7476, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6812, 37),
      ))
    }

@delegate:ResourceContentHash(-484_857_157)
internal val Res.string.gems_search_placeholder: StringResource by lazy {
      StringResource("string:gems_search_placeholder", "gems_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9022, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7522, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6850, 47),
      ))
    }

@delegate:ResourceContentHash(1_328_429_455)
internal val Res.string.gems_section_danestaniha: StringResource by lazy {
      StringResource("string:gems_section_danestaniha", "gems_section_danestaniha", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9216, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7676, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6988, 48),
      ))
    }

@delegate:ResourceContentHash(835_210_316)
internal val Res.string.gems_section_danestaniha_desc: StringResource by lazy {
      StringResource("string:gems_section_danestaniha_desc", "gems_section_danestaniha_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9086, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7586, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6898, 89),
      ))
    }

@delegate:ResourceContentHash(574_088_478)
internal val Res.string.gems_section_fal: StringResource by lazy {
      StringResource("string:gems_section_fal", "gems_section_fal", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9375, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7799, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7111, 40),
      ))
    }

@delegate:ResourceContentHash(1_304_149_389)
internal val Res.string.gems_section_fal_desc: StringResource by lazy {
      StringResource("string:gems_section_fal_desc", "gems_section_fal_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9277, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7725, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7037, 73),
      ))
    }

@delegate:ResourceContentHash(1_176_783_609)
internal val Res.string.gems_section_jokes: StringResource by lazy {
      StringResource("string:gems_section_jokes", "gems_section_jokes", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9524, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7924, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7232, 46),
      ))
    }

@delegate:ResourceContentHash(2_118_126_759)
internal val Res.string.gems_section_jokes_desc: StringResource by lazy {
      StringResource("string:gems_section_jokes_desc", "gems_section_jokes_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9420, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7840, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7152, 79),
      ))
    }

@delegate:ResourceContentHash(118_888_073)
internal val Res.string.gems_section_poetry: StringResource by lazy {
      StringResource("string:gems_section_poetry", "gems_section_poetry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9692, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8064, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7372, 47),
      ))
    }

@delegate:ResourceContentHash(-1_815_758_530)
internal val Res.string.gems_section_poetry_desc: StringResource by lazy {
      StringResource("string:gems_section_poetry_desc", "gems_section_poetry_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9575, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7975, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7279, 92),
      ))
    }

@delegate:ResourceContentHash(-855_764_040)
internal val Res.string.gems_section_recipes: StringResource by lazy {
      StringResource("string:gems_section_recipes", "gems_section_recipes", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9842, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8206, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7498, 52),
      ))
    }

@delegate:ResourceContentHash(1_712_067_860)
internal val Res.string.gems_section_recipes_desc: StringResource by lazy {
      StringResource("string:gems_section_recipes_desc", "gems_section_recipes_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9744, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8112, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7420, 77),
      ))
    }

@delegate:ResourceContentHash(-945_961_718)
internal val Res.string.gems_section_shahnameh: StringResource by lazy {
      StringResource("string:gems_section_shahnameh", "gems_section_shahnameh", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10003, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8335, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7627, 42),
      ))
    }

@delegate:ResourceContentHash(1_629_852_430)
internal val Res.string.gems_section_shahnameh_desc: StringResource by lazy {
      StringResource("string:gems_section_shahnameh_desc", "gems_section_shahnameh_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9907, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8263, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7551, 75),
      ))
    }

@delegate:ResourceContentHash(21_888_342)
internal val Res.string.gems_section_stories: StringResource by lazy {
      StringResource("string:gems_section_stories", "gems_section_stories", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10180, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8488, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7752, 48),
      ))
    }

@delegate:ResourceContentHash(2_142_075_722)
internal val Res.string.gems_section_stories_desc: StringResource by lazy {
      StringResource("string:gems_section_stories_desc", "gems_section_stories_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10054, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8382, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7670, 81),
      ))
    }

@delegate:ResourceContentHash(1_409_203_829)
internal val Res.string.gems_shahnameh_empty_desc: StringResource by lazy {
      StringResource("string:gems_shahnameh_empty_desc", "gems_shahnameh_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10245, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8537, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7801, 77),
      ))
    }

@delegate:ResourceContentHash(-1_721_832_284)
internal val Res.string.gems_shahnameh_empty_title: StringResource by lazy {
      StringResource("string:gems_shahnameh_empty_title", "gems_shahnameh_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10383, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8627, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7879, 50),
      ))
    }

@delegate:ResourceContentHash(-945_961_718)
internal val Res.string.gems_shahnameh_title: StringResource by lazy {
      StringResource("string:gems_shahnameh_title", "gems_shahnameh_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10462, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8702, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7930, 40),
      ))
    }

@delegate:ResourceContentHash(222_187_175)
internal val Res.string.gems_share_a11y: StringResource by lazy {
      StringResource("string:gems_share_a11y", "gems_share_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10511, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8747, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7971, 31),
      ))
    }

@delegate:ResourceContentHash(-594_920_992)
internal val Res.string.gems_share_message: StringResource by lazy {
      StringResource("string:gems_share_message", "gems_share_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10571, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8783, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8003, 42),
      ))
    }

@delegate:ResourceContentHash(1_125_113_571)
internal val Res.string.gems_sort_liked: StringResource by lazy {
      StringResource("string:gems_sort_liked", "gems_sort_liked", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10614, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8826, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8046, 39),
      ))
    }

@delegate:ResourceContentHash(-452_704_002)
internal val Res.string.gems_sort_newest: StringResource by lazy {
      StringResource("string:gems_sort_newest", "gems_sort_newest", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10666, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8874, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8086, 32),
      ))
    }

@delegate:ResourceContentHash(-810_360_149)
internal val Res.string.gems_sort_quickest: StringResource by lazy {
      StringResource("string:gems_sort_quickest", "gems_sort_quickest", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10715, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8923, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8119, 38),
      ))
    }

@delegate:ResourceContentHash(880_939_737)
internal val Res.string.gems_start_cooking: StringResource by lazy {
      StringResource("string:gems_start_cooking", "gems_start_cooking", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10770, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8974, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8158, 46),
      ))
    }

@delegate:ResourceContentHash(1_819_416_279)
internal val Res.string.gems_stat_cook: StringResource by lazy {
      StringResource("string:gems_stat_cook", "gems_stat_cook", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10825, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9029, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8205, 30),
      ))
    }

@delegate:ResourceContentHash(963_170_672)
internal val Res.string.gems_stat_difficulty: StringResource by lazy {
      StringResource("string:gems_stat_difficulty", "gems_stat_difficulty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10856, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9064, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8236, 44),
      ))
    }

@delegate:ResourceContentHash(1_492_658_964)
internal val Res.string.gems_stat_prep: StringResource by lazy {
      StringResource("string:gems_stat_prep", "gems_stat_prep", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10897, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9109, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8281, 30),
      ))
    }

@delegate:ResourceContentHash(762_192_500)
internal val Res.string.gems_stat_serves: StringResource by lazy {
      StringResource("string:gems_stat_serves", "gems_stat_serves", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10948, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9148, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8312, 32),
      ))
    }

@delegate:ResourceContentHash(1_790_207_910)
internal val Res.string.gems_steps_title: StringResource by lazy {
      StringResource("string:gems_steps_title", "gems_steps_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11001, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9185, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8345, 32),
      ))
    }

@delegate:ResourceContentHash(944_575_231)
internal val Res.string.gems_stories_empty_desc: StringResource by lazy {
      StringResource("string:gems_stories_empty_desc", "gems_stories_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11042, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9222, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8378, 75),
      ))
    }

@delegate:ResourceContentHash(-2_085_349_345)
internal val Res.string.gems_stories_empty_title: StringResource by lazy {
      StringResource("string:gems_stories_empty_title", "gems_stories_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11170, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9310, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8454, 52),
      ))
    }

@delegate:ResourceContentHash(21_888_342)
internal val Res.string.gems_stories_title: StringResource by lazy {
      StringResource("string:gems_stories_title", "gems_stories_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11247, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9383, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8507, 46),
      ))
    }

@delegate:ResourceContentHash(-618_554_000)
internal val Res.string.gems_story_read_time: StringResource by lazy {
      StringResource("string:gems_story_read_time", "gems_story_read_time", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11310, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9430, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8554, 48),
      ))
    }

@delegate:ResourceContentHash(1_979_988_692)
internal val Res.string.gems_story_region_iran: StringResource by lazy {
      StringResource("string:gems_story_region_iran", "gems_story_region_iran", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11379, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9487, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8603, 38),
      ))
    }

@delegate:ResourceContentHash(4_538_406)
internal val Res.string.gems_story_title: StringResource by lazy {
      StringResource("string:gems_story_title", "gems_story_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11426, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9526, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8642, 36),
      ))
    }

@delegate:ResourceContentHash(-706_181_512)
internal val Res.string.gems_subtitle: StringResource by lazy {
      StringResource("string:gems_subtitle", "gems_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11483, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9567, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8679, 109),
      ))
    }

@delegate:ResourceContentHash(319_680_796)
internal val Res.string.gems_swipe_hint: StringResource by lazy {
      StringResource("string:gems_swipe_hint", "gems_swipe_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11621, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9689, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8789, 47),
      ))
    }

@delegate:ResourceContentHash(-201_538_432)
internal val Res.string.gems_tale_image_a11y: StringResource by lazy {
      StringResource("string:gems_tale_image_a11y", "gems_tale_image_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11713, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9765, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8837, 52),
      ))
    }

@delegate:ResourceContentHash(1_244_371_056)
internal val Res.string.gems_tale_moral_label: StringResource by lazy {
      StringResource("string:gems_tale_moral_label", "gems_tale_moral_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11774, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9826, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8890, 41),
      ))
    }

@delegate:ResourceContentHash(-1_876_488_727)
internal val Res.string.gems_tale_not_found: StringResource by lazy {
      StringResource("string:gems_tale_not_found", "gems_tale_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11832, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9868, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8932, 47),
      ))
    }

@delegate:ResourceContentHash(1_487_971_537)
internal val Res.string.gems_time_30: StringResource by lazy {
      StringResource("string:gems_time_30", "gems_time_30", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11900, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9920, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8980, 36),
      ))
    }

@delegate:ResourceContentHash(1_498_557_718)
internal val Res.string.gems_time_60: StringResource by lazy {
      StringResource("string:gems_time_60", "gems_time_60", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11961, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9961, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9017, 36),
      ))
    }

@delegate:ResourceContentHash(259_689_254)
internal val Res.string.gems_time_90: StringResource by lazy {
      StringResource("string:gems_time_90", "gems_time_90", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12018, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10006, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9054, 40),
      ))
    }

@delegate:ResourceContentHash(1_269_458_574)
internal val Res.string.gems_time_any: StringResource by lazy {
      StringResource("string:gems_time_any", "gems_time_any", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12079, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10047, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9095, 33),
      ))
    }

@delegate:ResourceContentHash(1_273_324_432)
internal val Res.string.gems_title: StringResource by lazy {
      StringResource("string:gems_title", "gems_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12121, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10089, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9129, 34),
      ))
    }

@delegate:ResourceContentHash(903_811_407)
internal val Res.string.gems_unavailable_desc: StringResource by lazy {
      StringResource("string:gems_unavailable_desc", "gems_unavailable_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12176, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10132, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9164, 101),
      ))
    }

@delegate:ResourceContentHash(1_177_574_418)
internal val Res.string.gems_unavailable_title: StringResource by lazy {
      StringResource("string:gems_unavailable_title", "gems_unavailable_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12330, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10258, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9266, 66),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("gems_region_gilan", Res.string.gems_region_gilan)
  map.put("gems_region_hormozgan", Res.string.gems_region_hormozgan)
  map.put("gems_region_isfahan", Res.string.gems_region_isfahan)
  map.put("gems_region_kerman", Res.string.gems_region_kerman)
  map.put("gems_region_kermanshah", Res.string.gems_region_kermanshah)
  map.put("gems_region_khorasan", Res.string.gems_region_khorasan)
  map.put("gems_region_khuzestan", Res.string.gems_region_khuzestan)
  map.put("gems_region_kurdistan", Res.string.gems_region_kurdistan)
  map.put("gems_region_mashhad", Res.string.gems_region_mashhad)
  map.put("gems_region_mazandaran", Res.string.gems_region_mazandaran)
  map.put("gems_region_other", Res.string.gems_region_other)
  map.put("gems_region_qazvin", Res.string.gems_region_qazvin)
  map.put("gems_region_shiraz", Res.string.gems_region_shiraz)
  map.put("gems_region_sistan", Res.string.gems_region_sistan)
  map.put("gems_region_tabriz", Res.string.gems_region_tabriz)
  map.put("gems_region_tehran", Res.string.gems_region_tehran)
  map.put("gems_region_yazd", Res.string.gems_region_yazd)
  map.put("gems_report_action", Res.string.gems_report_action)
  map.put("gems_report_done", Res.string.gems_report_done)
  map.put("gems_report_failed", Res.string.gems_report_failed)
  map.put("gems_report_reason_offensive", Res.string.gems_report_reason_offensive)
  map.put("gems_report_reason_other", Res.string.gems_report_reason_other)
  map.put("gems_report_reason_spam", Res.string.gems_report_reason_spam)
  map.put("gems_report_sent", Res.string.gems_report_sent)
  map.put("gems_report_submit", Res.string.gems_report_submit)
  map.put("gems_report_title", Res.string.gems_report_title)
  map.put("gems_retry", Res.string.gems_retry)
  map.put("gems_save_a11y", Res.string.gems_save_a11y)
  map.put("gems_saved_action_a11y", Res.string.gems_saved_action_a11y)
  map.put("gems_saved_empty", Res.string.gems_saved_empty)
  map.put("gems_saved_rail", Res.string.gems_saved_rail)
  map.put("gems_saved_sheet_title", Res.string.gems_saved_sheet_title)
  map.put("gems_search_close_a11y", Res.string.gems_search_close_a11y)
  map.put("gems_search_open_a11y", Res.string.gems_search_open_a11y)
  map.put("gems_search_placeholder", Res.string.gems_search_placeholder)
  map.put("gems_section_danestaniha", Res.string.gems_section_danestaniha)
  map.put("gems_section_danestaniha_desc", Res.string.gems_section_danestaniha_desc)
  map.put("gems_section_fal", Res.string.gems_section_fal)
  map.put("gems_section_fal_desc", Res.string.gems_section_fal_desc)
  map.put("gems_section_jokes", Res.string.gems_section_jokes)
  map.put("gems_section_jokes_desc", Res.string.gems_section_jokes_desc)
  map.put("gems_section_poetry", Res.string.gems_section_poetry)
  map.put("gems_section_poetry_desc", Res.string.gems_section_poetry_desc)
  map.put("gems_section_recipes", Res.string.gems_section_recipes)
  map.put("gems_section_recipes_desc", Res.string.gems_section_recipes_desc)
  map.put("gems_section_shahnameh", Res.string.gems_section_shahnameh)
  map.put("gems_section_shahnameh_desc", Res.string.gems_section_shahnameh_desc)
  map.put("gems_section_stories", Res.string.gems_section_stories)
  map.put("gems_section_stories_desc", Res.string.gems_section_stories_desc)
  map.put("gems_shahnameh_empty_desc", Res.string.gems_shahnameh_empty_desc)
  map.put("gems_shahnameh_empty_title", Res.string.gems_shahnameh_empty_title)
  map.put("gems_shahnameh_title", Res.string.gems_shahnameh_title)
  map.put("gems_share_a11y", Res.string.gems_share_a11y)
  map.put("gems_share_message", Res.string.gems_share_message)
  map.put("gems_sort_liked", Res.string.gems_sort_liked)
  map.put("gems_sort_newest", Res.string.gems_sort_newest)
  map.put("gems_sort_quickest", Res.string.gems_sort_quickest)
  map.put("gems_start_cooking", Res.string.gems_start_cooking)
  map.put("gems_stat_cook", Res.string.gems_stat_cook)
  map.put("gems_stat_difficulty", Res.string.gems_stat_difficulty)
  map.put("gems_stat_prep", Res.string.gems_stat_prep)
  map.put("gems_stat_serves", Res.string.gems_stat_serves)
  map.put("gems_steps_title", Res.string.gems_steps_title)
  map.put("gems_stories_empty_desc", Res.string.gems_stories_empty_desc)
  map.put("gems_stories_empty_title", Res.string.gems_stories_empty_title)
  map.put("gems_stories_title", Res.string.gems_stories_title)
  map.put("gems_story_read_time", Res.string.gems_story_read_time)
  map.put("gems_story_region_iran", Res.string.gems_story_region_iran)
  map.put("gems_story_title", Res.string.gems_story_title)
  map.put("gems_subtitle", Res.string.gems_subtitle)
  map.put("gems_swipe_hint", Res.string.gems_swipe_hint)
  map.put("gems_tale_image_a11y", Res.string.gems_tale_image_a11y)
  map.put("gems_tale_moral_label", Res.string.gems_tale_moral_label)
  map.put("gems_tale_not_found", Res.string.gems_tale_not_found)
  map.put("gems_time_30", Res.string.gems_time_30)
  map.put("gems_time_60", Res.string.gems_time_60)
  map.put("gems_time_90", Res.string.gems_time_90)
  map.put("gems_time_any", Res.string.gems_time_any)
  map.put("gems_title", Res.string.gems_title)
  map.put("gems_unavailable_desc", Res.string.gems_unavailable_desc)
  map.put("gems_unavailable_title", Res.string.gems_unavailable_title)
}
